"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const BackButton_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/BackButton.vue"));
const StatsCard_vue_1 = __importDefault(require("@becrop/components/Toolkit/Cooccurrence/vue/StatsCard.vue"));
// @ts-ignore
const venn = __importStar(require("venn.js"));
const d3 = __importStar(require("d3"));
const debounce_1 = require("@common/tsutils/debounce");
const VennModal_vue_1 = __importDefault(require("@becrop/components/Toolkit/Cooccurrence/vue/VennModal.vue"));
const trans_1 = require("@common/tsutils/trans");
let CooccurrenceTool = class CooccurrenceTool extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.ClusterColours = ["#3FB8B2", "#6C3FB8", "#DB756F", "#CF8944", "#E6C93B"];
        this.modal_cluster = null;
        this.modal_active = false;
        this.modal_type = 'null';
    }
    get _uid() {
        return Math.random();
    }
    created() {
        window.addEventListener("resize", this.onResize);
    }
    destroyed() {
        window.removeEventListener("resize", this.onResize);
    }
    onResize() {
        this.draw_venn();
    }
    toClusterEdition() {
        this.$emit('to-cluster');
    }
    leyenda_classes() {
        const classes = {
            leyenda: true,
        };
        classes['leyenda--' + this.clusters.filled_clusters] = true;
        return classes;
    }
    mounted() {
        this.draw_venn();
    }
    draw_venn() {
        //
        // Build the venn sets from the combination of clusters
        //
        const sets = this.cooccurrenceResult.venn.map(function (combination) {
            const sets = combination.clusters.map(function (x) {
                return '#' + (x + 1);
            });
            return { sets: sets, size: combination.num };
        });
        let sharedtitle = (0, trans_1.trans)('toolkit.coocurrence.organisms_shared');
        let orgsinitle = (0, trans_1.trans)('toolkit.coocurrence.organisms_in');
        //
        // Create the venn diagram
        //
        let the_width = window.innerWidth;
        let chartwidth;
        (the_width < 640) ? chartwidth = (the_width - 75) : chartwidth = 600;
        const chart = venn.VennDiagram()
            .width(chartwidth)
            .height(chartwidth / (16 / 9));
        const the_chart = d3.select(this.$refs.venn).datum(sets).call(chart);
        the_chart.selectAll("text").style("fill", "white").style("pointer-events", "none");
        the_chart.selectAll(".venn-circle path")
            .style("stroke-width", 3)
            .style("stroke", "fff")
            .style("stroke-opacity", 0)
            .style("fill-opacity", .6)
            .style("fill", (d, i) => {
            return this.ClusterColours[this.cooccurrenceResult.cluster_idxs[i]];
        });
        let tooltip = d3.select("#venn").append("div")
            .attr("class", "venn__tooltip");
        the_chart.selectAll("g")
            //d3.selectAll("g")
            .on("mouseover", function (event, d) {
            venn.sortAreas(the_chart, d);
            if (d3.select(this).classed("venn-intersection")) {
                d3.select(this).select("path")
                    .style("stroke-opacity", 1)
                    .style("stroke", "fff")
                    .style("stroke-width", 3)
                    .style("fill-opacity", 0.5)
                    .style("fill", "fff");
            }
            else {
                d3.select(this).select("path")
                    .style("stroke-opacity", 1)
                    .style("fill-opacity", 0.9);
            }
            tooltip.transition().duration(40).style("opacity", 1);
            if (d.sets.length === 1) {
                //const l1 = trans('toolkit.coocurrence.organisms_in');
                const l1 = orgsinitle;
                tooltip.text(`${d.size} ${l1} ${d.sets}`);
            }
            else {
                //const l2 = trans('toolkit.coocurrence.organisms_shared');
                const l2 = sharedtitle;
                tooltip.text(`${d.size} ${l2} ${d.sets}`);
            }
        })
            .on("mousemove", function (event) {
            tooltip.style("left", (event.x) - 120 + "px")
                .style("top", (event.y) - 170 + "px");
        })
            .on("mouseout", function (event, d) {
            tooltip.transition()
                .duration(400)
                .style("opacity", 0);
            const selection = d3.select(this).transition("tooltip")
                .duration(400);
            selection.select("path")
                .style("stroke-width", 3)
                .style("fill-opacity", d.sets.length === 1 ? .6 : 0)
                .style("stroke-opacity", 0);
        });
    }
    onModal(type, cluster) {
        this.modal_cluster = cluster;
        this.modal_active = true;
        this.modal_type = type;
    }
    downloadRaw() {
        this.cooccurrenceResult.downloadRaw();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CooccurrenceTool.prototype, "is_biome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CooccurrenceTool.prototype, "cooccurrenceResult", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CooccurrenceTool.prototype, "clusters", void 0);
__decorate([
    (0, debounce_1.PerInstanceDebounce)(200)
], CooccurrenceTool.prototype, "onResize", null);
CooccurrenceTool = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            VennModal: VennModal_vue_1.default,
            StatsCard: StatsCard_vue_1.default,
            BackButton: BackButton_vue_1.default,
        }
    })
], CooccurrenceTool);
exports.default = CooccurrenceTool;
